import { Button, Typography } from '@mui/material'
import { commonBtnStyles, commonTypoStyles } from '~/constants/commonBtnStyles'
import React from 'react'
import { AiFillApple } from 'react-icons/ai'

type Props = {
  name: string
  'aria-label': string
  value: string
  onClick?: () => void
  disabled?: boolean
  className?: string
  fullWidth?: boolean
}

const AppleBtnStyle = {
  backgroundColor: '#000',
  color: '#fff',
}

export const AppleButton: React.FC<Props> = (props) => {
  const { value, ...rest } = props
  return (
    <Button
      {...rest}
      variant="contained"
      startIcon={<AiFillApple size={24} />}
      sx={{
        ...AppleBtnStyle,
        ...commonBtnStyles,
        ':hover': { backgroundColor: '#000000ca' },
      }}
    >
      <Typography
        sx={{
          ...commonTypoStyles,
        }}
      >
        {value}
      </Typography>
    </Button>
  )
}
